import { DEMO_ADMIN_USER, DEMO_REFRESH_TOKEN, DEMO_TOKEN } from './demoSession';

let activeRefCount = 0;
let savedSession = null;
const SAVED_SESSION_KEY = 'unified-workforce:demo-saved-session';

const readCurrentSession = () => ({
  token: localStorage.getItem('token'),
  refresh_token: localStorage.getItem('refresh_token'),
  user: localStorage.getItem('user'),
});

const restoreSession = (session) => {
  const restore = (key, value) => {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  };

  restore('token', session?.token);
  restore('refresh_token', session?.refresh_token);
  restore('user', session?.user);
};

const persistSavedSession = (session) => {
  try {
    sessionStorage.setItem(SAVED_SESSION_KEY, JSON.stringify(session));
  } catch (_) {}
};

const clearPersistedSession = () => {
  try {
    sessionStorage.removeItem(SAVED_SESSION_KEY);
  } catch (_) {}
};

// A hard reload can interrupt React cleanup while the sample workspace is open.
// Recover the visitor's original session before the landing page renders again.
if (typeof window !== 'undefined' && localStorage.getItem('token') === DEMO_TOKEN) {
  let interruptedSession = null;
  try {
    interruptedSession = JSON.parse(sessionStorage.getItem(SAVED_SESSION_KEY) || 'null');
  } catch (_) {}
  restoreSession(interruptedSession);
  clearPersistedSession();
}

export const isDemoModeActive = () => activeRefCount > 0;

export function activateDemoMode() {
  if (activeRefCount === 0) {
    savedSession = readCurrentSession();
    persistSavedSession(savedSession);
    localStorage.setItem('token', DEMO_TOKEN);
    localStorage.setItem('refresh_token', DEMO_REFRESH_TOKEN);
    localStorage.setItem('user', JSON.stringify(DEMO_ADMIN_USER));
  }
  activeRefCount += 1;
}

export function deactivateDemoMode() {
  activeRefCount = Math.max(0, activeRefCount - 1);
  if (activeRefCount > 0) return;

  restoreSession(savedSession);
  savedSession = null;
  clearPersistedSession();
}
